<span>
  {{ buildTranslationKey('text') | translate }}
</span>
<button
  data-test-id="activate-update-btn"
  class="border-0 font-bold underline"
  (click)="activateUpdate()"
>
  {{ buildTranslationKey('submitBtn') | translate }}
</button>
